import React from 'react';

import './checkout-item.scss';

import { clearItemFromCart, removeItem, addItem} from '../../redux/cart/cart-action';

import { useDispatch } from 'react-redux';

const CheckoutItem = ({cartItem}) =>{
    
    const dispatch = useDispatch();

    const {name, imageUrl, price, quantity} = cartItem;
    return(

        <div className='checkout-item'>
            <div className='image-container'>
                <img src={imageUrl} alt='item'/>
            </div>

            <span className='name'>{name}</span>
            <span className='quantity'>
                <div className='arrow' onClick={()=>dispatch(removeItem(cartItem))}>
                    &#10094;
                </div>
                <span className='value'>{quantity}</span>
                <div className='arrow' onClick={()=>dispatch(addItem(cartItem))}>
                &#10095;
                </div>
            </span>
            <span className='price'>{price}</span>
            <span className='remove-button' onClick ={()=> dispatch(clearItemFromCart(cartItem))}> X </span>

        </div>
    )
}
export default CheckoutItem;